import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromOrders from './orders.reducer';

export const selectOrdersState = createFeatureSelector<fromOrders.State>(
  fromOrders.ordersFeatureKey
);

export const selectPreviousOrdersState = createSelector(
  selectOrdersState,
  (state) => state.list
);

export const selectSingleOrder = createSelector(
  selectPreviousOrdersState,
  (state, props) => state.entities[props.id]
);

export const selectNewOrder = createSelector(
  selectOrdersState,
  (state) => state.newOrder
);
